module.exports = __webpack_public_path__ + "static/media/Group 19.668074db.png";